/*
 * variant-media-filter.js
 * カラーvariant選択時に、その色の画像＋共通画像のみをギャラリー/サムネ/モーダルに表示する。
 * - 画像の色は liquid 側で各メディア要素に付与した data-media-color から取得（alt の "::color=" トークン由来）。
 * - data-media-color が空（共通カット）or 選択色と一致 する要素のみ表示、他は hidden。
 * - 色トークンを持つ画像が1枚も無い商品は一切フィルタしない（従来通り全表示）。
 * - Dawn の slider-component / media-gallery を壊さない（initPages で非表示分は自動的に詰まる）。
 */
(function () {
  'use strict';

  function getColorOptionFromVariant(variant) {
    if (!variant || !variant.options) return null;
    // tutie のカラーオプション値（商品のオプション値と完全一致するものを拾う）
    // options 配列のうち、メディアの data-media-color に存在する値と一致するものを色とみなす。
    return variant.options;
  }

  function normalize(s) {
    return (s == null ? '' : String(s)).trim();
  }

  function ProductFilter(productInfo) {
    this.root = productInfo;
    this.gallery = productInfo.querySelector('media-gallery');
    this.modal = productInfo.querySelector('product-modal');
    // この商品が色トークンを1つでも持つか（持たなければ何もしない）
    this.colorValues = this.collectColorValues();
    this.hasColorTokens = this.colorValues.length > 0;
  }

  ProductFilter.prototype.collectColorValues = function () {
    var set = {};
    if (this.gallery) {
      this.gallery.querySelectorAll('[data-media-color]').forEach(function (el) {
        var c = normalize(el.getAttribute('data-media-color'));
        if (c) set[c] = true;
      });
    }
    return Object.keys(set);
  };

  // variant.options の中から、画像の色トークン集合に一致する値を選ぶ
  ProductFilter.prototype.pickColorFromOptions = function (options) {
    if (!options) return null;
    for (var i = 0; i < options.length; i++) {
      var v = normalize(options[i]);
      if (this.colorValues.indexOf(v) !== -1) return v;
    }
    return null;
  };

  ProductFilter.prototype.apply = function (selectedColor) {
    if (!this.hasColorTokens) return;
    var color = normalize(selectedColor);

    // メイン画像 li / サムネ li / モーダル img を対象に
    // ★モーダルは常に再取得する（product-modal は初回ページロード時点でDOMに
    // 存在しないことがあり、コンストラクタでの1回キャッシュだとnullのまま
    // 固定されてしまい、以降ずっとモーダル側にフィルタが効かなくなるため）。
    if (!this.modal) {
      this.modal = this.root.querySelector('product-modal') || document.querySelector('product-modal');
    }

    var nodes = [];
    if (this.gallery) {
      this.gallery.querySelectorAll('li[data-media-color]').forEach(function (n) { nodes.push(n); });
    }
    if (this.modal) {
      this.modal.querySelectorAll('[data-media-color]').forEach(function (n) { nodes.push(n); });
    }

    nodes.forEach(function (node) {
      var c = normalize(node.getAttribute('data-media-color'));
      // 共通(空) か 選択色一致 → 表示、他 → 非表示
      var show = c === '' || (color && c === color) || !color;
      if (show) {
        node.hidden = false;
        node.removeAttribute('hidden');
        node.style.removeProperty('display');
        // ★最重要：この商品は画像が多く(40〜50枚超)、初期表示されない色の
        // <img loading="lazy"> はページ読込時 display:none のためブラウザの
        // ネイティブ遅延読み込みが一度も発火せず、色を切り替えて表示に戻しても
        // 画像が空白（naturalWidth:0, complete:false）のままになる実例を実機で確認。
        // 表示に切り替えるタイミングで loading="eager" にして強制的に読み込ませる。
        node.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
        if (node.tagName === 'IMG' && node.getAttribute('loading') === 'lazy') {
          node.loading = 'eager';
        }
      } else {
        // ★通常の style.display='none' だと、Dawnのモーダル/スライダーCSSが
        // "display: flex !important" 等で子要素に強制指定している場合に
        // 上書きされ非表示にならないことを実機で確認した。!important 付きで
        // 設定することで確実に隠す。
        node.hidden = true;
        node.style.setProperty('display', 'none', 'important');
      }
    });

    this.resync();
  };

  // スライダー/カウンター/アクティブを表示中メディアに合わせ再同期
  ProductFilter.prototype.resync = function () {
    if (!this.gallery) return;
    var gallery = this.gallery;

    // 先頭の可視メイン画像を取得
    var mainItems = gallery.querySelectorAll('.product__media-item[data-media-id]');
    var firstVisible = null;
    for (var i = 0; i < mainItems.length; i++) {
      if (mainItems[i].style.display !== 'none' && !mainItems[i].hidden) { firstVisible = mainItems[i]; break; }
    }

    // 先頭可視メディアをアクティブに（media-gallery.setActiveMedia を利用）
    // slider-component の update() より先に呼ぶ：is-active が非表示要素を指したまま
    // update() が内部で offsetLeft を読みに行くと例外になり、以降の再同期が丸ごと止まるため。
    if (firstVisible && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
    }

    // slider-component の再ページ計算（非表示分は clientWidth=0 で自動除外される）
    var sliders = gallery.querySelectorAll('slider-component');
    sliders.forEach(function (sc) {
      if (typeof sc.initPages === 'function') {
        // スクロール位置を先頭へ戻してからページ再計算
        if (sc.slider) sc.slider.scrollLeft = 0;
        try {
          sc.initPages();
          if (typeof sc.update === 'function') sc.update();
        } catch (e) {
          // スライダー内部のアクティブスライド参照が非表示要素と食い違い例外になることがある。
          // is-active の更新は上で完了済みのため、ここは握りつぶして表示自体は継続させる。
        }
      }
    });
  };

  function init(productInfo) {
    if (!productInfo || productInfo.__variantMediaFilter) return;
    var pf = new ProductFilter(productInfo);
    if (!pf.hasColorTokens) return; // 色トークンが無い商品は対象外
    productInfo.__variantMediaFilter = pf;

    // 初期：現在選択中 variant の色で適用
    var initialColor = readSelectedColor(productInfo, pf);
    pf.apply(initialColor);

    // variant 変更購読（Dawn pub/sub）
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      pf.__unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data) return;
        // 同一セクションのみ
        if (data.sectionId && pf.root.dataset && pf.root.dataset.section &&
            String(data.sectionId) !== String(pf.root.dataset.section)) {
          // productInfo の sectionId と一致しなければスキップ
        }
        var color = pf.pickColorFromOptions(data.variant && data.variant.options);
        // updateMedia による DOM 入替後に適用するため少し遅らせて実行。
        // requestAnimationFrame はタブが非アクティブ/非表示だと発火が止まり、
        // その間カラー切替が一切反映されなくなる実例を確認したため setTimeout に変更。
        // ★画像枚数が多い商品（40〜50枚超）では、Dawn側のギャラリーDOM入替が
        // 単発のsetTimeout(fn,0)より後に完了することがあり、1回目の適用だけでは
        // 一部スライドが古い色のまま残る／アクティブスライドが非表示スライドを
        // 指したままになりビューが空白に見える実例を確認。複数回・間隔を空けて
        // 再適用することで、入替タイミングのブレを吸収する。
        [0, 150, 400, 900].forEach(function (delay) {
          setTimeout(function () {
            pf.colorValues = pf.collectColorValues();
            pf.hasColorTokens = pf.colorValues.length > 0;
            var c = color || pf.pickColorFromOptions(data.variant && data.variant.options);
            pf.apply(c);
          }, delay);
        });
      });
    }

    // フォールバック：カラー入力の change を直接拾う
    productInfo.querySelectorAll('variant-selects, variant-radios').forEach(function (vs) {
      vs.addEventListener('change', function () {
        [0, 150, 400, 900].forEach(function (delay) {
          setTimeout(function () {
            var c = readSelectedColor(productInfo, pf);
            pf.apply(c);
          }, delay);
        });
      });
    });

    // ★モーダル（拡大表示）は画像が遅延生成されるDawnの実装のため、
    // variant切替時点のDOMに存在せずフィルタが当たらないことがある。
    // モーダルを開く直前に現在色で再適用し、開いた瞬間から正しい色だけを見せる。
    if (pf.modal && typeof pf.modal.show === 'function' && !pf.modal.__variantMediaFilterPatched) {
      pf.modal.__variantMediaFilterPatched = true;
      var originalShow = pf.modal.show.bind(pf.modal);
      pf.modal.show = function (opener) {
        var c = readSelectedColor(productInfo, pf);
        pf.apply(c);
        return originalShow(opener);
      };
    }
  }

  // 現在 UI で選択中のカラー値を読む（option名に依存せず、色トークン集合と一致する選択値を探す）
  function readSelectedColor(productInfo, pf) {
    // radio / swatch
    var checked = productInfo.querySelectorAll(
      'variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked'
    );
    for (var i = 0; i < checked.length; i++) {
      var v = normalize(checked[i].value);
      if (pf.colorValues.indexOf(v) !== -1) return v;
    }
    // select(dropdown)
    var selects = productInfo.querySelectorAll('variant-selects select');
    for (var j = 0; j < selects.length; j++) {
      var sv = normalize(selects[j].value);
      if (pf.colorValues.indexOf(sv) !== -1) return sv;
    }
    return null;
  }

  function boot() {
    document.querySelectorAll('product-info').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // セクション再描画（テーマエディタ等）にも対応
  document.addEventListener('shopify:section:load', boot);
})();
